import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { IQueryInvoker, QUERY_INVOKER, Tlob } from "@ebootis/common";

@Injectable({providedIn: 'root'})
export class ArticleSearch
{
	constructor(@Inject(QUERY_INVOKER) private m_queryInvoker: IQueryInvoker) { }
	query(params: ArticleSearch.Params): Observable<ArticleSearch.Result>
	{
		return this.m_queryInvoker.doQuery("ArticleSearch", params);
	}
};

export namespace ArticleSearch
{
	export class Params
	{
		search?: string;
		sortBy?: string;
		logisticsAreaProxy?: string;
		attrValue1?: string;
		attrValue2?: string;
		attrValue3?: string;
		netPriceMin?: number;
		netPriceMax?: number;
		page?: number;
		limit: number;
		noLogisticsAreaFilter?: boolean;
		config: string;
	};
	export interface Result
	{
		articles?: Article[];
		count?: number;
	};
	export interface Article
	{
		oid?: string;
		id?: string;
		descrLong?: string;
		isVariantBase?: boolean;
		isStockArticle?: boolean;
		freeContingent?: number;
		customerPrice?: number;
		currencyCode?: string;
		proxyOid?: string;
		salesAmountMin?: number;
		salesAmountMax?: number;
		storagePackaging?: StoragePackaging;
		subPackaging?: SubPackaging;
		availableNow?: number;
		unit?: string;
		hasThumb?: boolean;
	};
	export interface StoragePackaging
	{
		factor?: number;
		unit?: string;
	};
	export interface SubPackaging
	{
		factor?: number;
		unit?: string;
	};
};
